'use client';

import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { useEffect, useRef } from 'react';

const gaTimerNumber1 = 20 * 1000; //多少秒后初始化GA
export default function GlobalUserAction({
    gaTimerNumberA = gaTimerNumber1,
    eventsBusName = 'GlobalUserAction-end-global',
}: {
    locale?: string;
    pathname?: string;
    gaTimerNumberA?: number;
    eventsBusName?: string;
}) {
    const hasInitFlag = useRef(false); //用于只执行1次
    const userActionTimerA = useRef<any>(null); //保底-倒计时
    // 开始事件
    const __startUserHandle = () => {
        if (hasInitFlag.current) {
            return;
        }
        hasInitFlag.current = true; //执行了
        EcoDesignEventsBus.emit(eventsBusName);
        cancelEventHandle();
    };
    // 绑定事件-滚动
    const addEventHandleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop < 50) {
            return;
        }
        __startUserHandle(); //__开始执行
    };
    // 绑定事件-点击
    const documentClickHandle = () => {
        __startUserHandle(); //__开始执行
    };
    // 用户没有任何行为,多少秒后执行倒计时
    const gATimerHandle = () => {
        userActionTimerA.current = setTimeout(() => {
            __startUserHandle(); //__开始执行
        }, gaTimerNumberA);
    };
    // 绑定事件
    const addEventHandle = () => {
        window.addEventListener('scroll', addEventHandleScroll);
        document.body.addEventListener('click', documentClickHandle);
        gATimerHandle();
    };
    // 取消事件-所有
    const cancelEventHandle = () => {
        try {
            window.removeEventListener('scroll', addEventHandleScroll);
            document.body.removeEventListener('click', documentClickHandle);
            clearTimeout(userActionTimerA.current);
        } catch (error) {}
    };
    const initHandleAll = () => {
        addEventHandle();
    };
    useEffect(() => {
        initHandleAll();
    }, []);
    return null;
}
